import { ColumnType } from '@dynamika-shared/ui/Table/Table.types';
import { getValueWithTooltip } from '@dynamika-shared/ui/Table/getValueWithTooltip';
import { Questionnaire } from '@dynamika-shared/types/questionnaire';
import { TrashIcon } from '@dynamika-shared/ui/icons';
import { FormsControlSchemaType } from 'src/pages/ClinicalTrial/uiControlSchemaByStatus/ControlTypes';

type MakeClinicalTrialsFormsColumnsType = {
  onDeleteClick: (id: string) => void;
  formSchema: FormsControlSchemaType;
};

const LENGTH_FOR_TOOLTIP = 10;

export function makeClinicalTrialsFormsColumns(
  props: MakeClinicalTrialsFormsColumnsType,
  isPM: boolean = false
): ColumnType<Questionnaire>[] {
  return [
    {
      name: 'name',
      header() {
        return 'Name';
      },

      loading: index => {
        const width = Number(index) % 2 ? `w-[${20}rem]` : `w-[${17}rem]`;
        return (
          <div
            className={`h-2 ${width} animate-pulse rounded-[5px] bg-brightGray`}
          ></div>
        );
      },
      getValue: getValueWithTooltip('name', LENGTH_FOR_TOOLTIP),
      cellClassName: 'max-w-full min-w-0 grow',
      tdClassName: 'min-w-full max-w-[30rem] mr-1',
      thClassName: 'w-[20.5%] min-w-[20.5%] max-w-[20.5%]',
    },
    {
      name: 'alias',
      header() {
        return 'Alias';
      },

      loading: () => (
        <div
          className={'h-2 w-[10rem] animate-pulse rounded-[5px] bg-brightGray'}
        ></div>
      ),
      getValue: getValueWithTooltip('alias', LENGTH_FOR_TOOLTIP),
      tdClassName: 'min-w-[16rem]',
      thClassName: 'w-[16.3%] min-w-[16.3%] max-w-[16.3%]',
    },
    {
      name: 'actions',
      header() {
        return  !isPM && 'Action';
      },
      loading: () => (
        <div className='h-3 w-3 animate-pulse rounded-md bg-brightGray'></div>
      ),
      getValue(row) {
        return (<div>
          {!props.formSchema.deleteForm.hidden && !isPM && <TrashIcon
            className='cursor-pointer hover:text-redOrange'
            width={24}
            height={24}
            onClick={() => props.onDeleteClick(row.id)}
            data-tesitid={`deleteSpecVisit-${row.id}`}
          />}
        </div>

        );
      },
      alignToRight: true,
      cellClassName: 'min-w-[5.7rem]',
      thClassName: 'w-[10rem] z-10',
    },
  ];
}
